import React, { Component } from 'react';
import DocumentMeta from 'react-document-meta';

class About extends Component {
  render() {
    return (
      <DocumentMeta title="Om SparPenge.dk" extend>
        <h3>Om SparPenge.dk</h3>
        <p>
          SparPenge.dk er en service, der hjælper dig med at spare penge. Her
          får du det fulde overblik over udbydere af lån, A-kasser, bredbånd,
          mobilabonnementer, tv-pakker og taletidskort. Produkter kan hurtigt og
          nemt sammenlignes på pris samt andre relevante parametre. Vi holder
          hele tiden øje med udbydernes tilbud, produkt- og prisændringer, som
          kan hjælpe dig til at spare penge.
        </p>
        <p>
          SparPenge.dk er en kommerciel tjeneste og modtager provision fra
          udbydere der omtales / henvises til. Lister omfatter ikke alle
          udbydere og produkter. Rækkefølge er påvirket af samarbejdet med
          udbydere. Info om produkter og tilbud indsamles fra udbyderne, og vi
          tager forbehold for fejl. Vi anvender cookies og registrerer adfærd
          jvf. privatlivspolitik og vilkår.
        </p>
      </DocumentMeta>
    );
  }
}

export default About;
